import PropTypes from 'prop-types';
import React from 'react';
import { getCloudinaryVideoPathById } from '../../../utilities/images';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';

export default class ResponsiveVideo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            width: this.props.width,
            height: this.props.height,
            volume: true,
        };
    }

    static propTypes = {
        /**
         * Image Source (Cloudinary Id)
         * */
        cloudinaryID: PropTypes.string.isRequired,
        /**
         * on fly transform size of video
         * */
        width: PropTypes.number,
        height: PropTypes.number,
        /**
         * load the media from cloudfront instead of cloudinary
         */
        loadFromCloudFont: PropTypes.bool,
        /**
         * whether to emit the metrics
         */
        emitMetric: PropTypes.bool,
        videoDimensions: PropTypes.object,
    };

    static defaultProps = {
        cloudinaryID: '',
        width: 320,
        height: 180,
        loadFromCloudFont: true,
        emitMetric: false,
        videoDimensions: {},
        enableAutoResizing: true,
    };

    componentDidMount() {
        if (window && this.props.enableAutoResizing) {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
        }
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener('resize', this.updateWindowDimensions);
        }
    }

    updateWindowDimensions = () => {
        const videoContainer =
            window.document.getElementById('video-container') || {};
        const { clientWidth, clientHeight } = videoContainer;
        this.setState({ width: clientWidth, height: clientHeight });
    };

    emitMetrics = (extraMetric) => {
        EmitMetric(
            Object.assign(
                extraMetric,
                { misc_event_count: 1 },
                this.props.videoDimensions
            )
        );
    };

    onPlaying = () => {
        const metric = this.props.metric || { misc_event_type: 'video-play' };
        this.emitMetrics(metric);
    };

    onPausing = () => {
        this.emitMetrics({ misc_event_type: 'video-pause' });
    };

    onVolumeChange = () => {
        this.setState({ volume: !this.state.volume }, () => {
            const action = this.state.volume ? 'unMute' : 'mute';
            this.emitMetrics({ misc_event_type: 'video-' + action });
        });
    };

    render() {
        return (
            <div className="component-Elements-Video" id="video-container">
                <video
                    width="100%"
                    height="auto"
                    controls
                    onPlaying={this.onPlaying}
                    onPause={this.onPausing}
                    onVolumeChange={this.onVolumeChange}
                >
                    <source
                        src={getCloudinaryVideoPathById(
                            this.props.cloudinaryID,
                            this.state.width,
                            Math.floor((this.state.width * 18) / 32),
                            this.props.loadFromCloudFont
                        )}
                        type="video/mp4"
                    />
                </video>
            </div>
        );
    }
}
